import { render } from "./slide12.vue?vue&type=template&id=23570300&scoped=true"
import script from "./slide12.vue?vue&type=script&lang=js"
export * from "./slide12.vue?vue&type=script&lang=js"

import "./slide12.vue?vue&type=style&index=0&id=23570300&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23570300"]])

export default __exports__